import React from 'react';
import Icon from './icon';
import './lane.css';

/**
 * Lane
 */
const Lane = ({ id, value, filter, filterValue, options=[], onChange, onCustom, clear, custom }) => {

  const onValueChange = (value) => {
    return () => {
      onChange(id, value);
    }
  }

  const renderClear = () => {
    return clear ? (
      <div className="lane-item" onClick={onValueChange(null)}>
        <Icon icon="close" className="small square"/>
      </div>
    ) : '';
  }

  const renderCustom = () => {
    return custom ? (
      <div className="lane-item" onClick={onCustom}>
        <Icon icon="edit" className="small square"/>
      </div>
    ) : '';
  }

  return (
    <div className="lane">
      { options
          .filter( option => filterValue ? option.filter === filterValue : true )
          .map( option => <div key={option.value} className="lane-item" onClick={onValueChange(option.value)}>{option.label}</div>)
      }
      <span></span>
      {renderCustom()}
    </div>
  )
}

export default Lane;



// WEBPACK FOOTER //
// ./src/lib/components/lane.js